import { render, staticRenderFns } from "./Newslist.vue?vue&type=template&id=790b11d7"
import script from "./Newslist.vue?vue&type=script&lang=js"
export * from "./Newslist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports